module.exports = __webpack_public_path__ + "img/hall_slide02.6d88853b.jpg";